"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UiPostOperations", {
    enumerable: true,
    get: function() {
        return UiPostOperations;
    }
});
const _common = require("@nestjs/common");
const _datatableservice = require("~/services/data-table.service");
const _tablesservice = require("~/services/tables.service");
const _columnsservice = require("~/services/columns.service");
const _viewsservice = require("~/services/views.service");
const _viewcolumnsservice = require("~/services/view-columns.service");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _filtersservice = require("~/services/filters.service");
const _sortsservice = require("~/services/sorts.service");
const _hooksservice = require("~/services/hooks.service");
const _gridsservice = require("~/services/grids.service");
const _gridcolumnsservice = require("~/services/grid-columns.service");
const _formsservice = require("~/services/forms.service");
const _formcolumnsservice = require("~/services/form-columns.service");
const _galleriesservice = require("~/services/galleries.service");
const _kanbansservice = require("~/services/kanbans.service");
const _mapsservice = require("~/services/maps.service");
const _calendarsservice = require("~/services/calendars.service");
const _commentsservice = require("~/services/comments.service");
const _bulkdataaliasservice = require("~/services/bulk-data-alias.service");
const _syncservice = require("~/services/sync.service");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _Jobs = require("~/interface/Jobs");
const _nocojobsservice = require("~/services/noco-jobs.service");
const _extensionsservice = require("~/services/extensions.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let UiPostOperations = class UiPostOperations {
    async handle(context, { payload, req, operation }) {
        switch(operation){
            case 'tableUpdate':
                return await this.tablesService.tableUpdate(context, {
                    tableId: req.query.tableId,
                    table: payload,
                    user: req.user,
                    req
                });
            case 'tableDelete':
                return await this.tablesService.tableDelete(context, {
                    tableId: req.query.tableId,
                    user: req.user,
                    forceDeleteRelations: payload == null ? void 0 : payload.forceDeleteRelations,
                    req
                });
            case 'tableReorder':
                return await this.tablesService.reorderTable(context, {
                    tableId: req.query.tableId,
                    order: payload.order,
                    req
                });
            case 'columnAdd':
                return await this.columnsService.columnAdd(context, {
                    tableId: req.query.tableId,
                    column: payload,
                    user: req.user,
                    req
                });
            case 'columnUpdate':
                return await this.columnsService.columnUpdate(context, {
                    columnId: req.query.columnId,
                    column: payload,
                    user: req.user,
                    req
                });
            case 'columnDelete':
                return await this.columnsService.columnDelete(context, {
                    columnId: req.query.columnId,
                    user: req.user,
                    req
                });
            case 'columnSetAsPrimary':
                return await this.columnsService.columnSetAsPrimary(context, {
                    columnId: req.query.columnId,
                    req
                });
            case 'columnsBulk':
                return await this.columnsService.columnBulk(context, req.query.tableId, payload, req);
            case 'viewUpdate':
                return await this.viewsService.viewUpdate(context, {
                    viewId: req.query.viewId,
                    view: payload,
                    user: req.user,
                    req
                });
            case 'viewDelete':
                return await this.viewsService.viewDelete(context, {
                    viewId: req.query.viewId,
                    user: req.user,
                    req
                });
            case 'shareView':
                return await this.viewsService.shareView(context, {
                    viewId: req.query.viewId,
                    user: req.user,
                    req
                });
            case 'shareViewUpdate':
                return await this.viewsService.shareViewUpdate(context, {
                    viewId: req.query.viewId,
                    sharedView: payload,
                    user: req.user,
                    req
                });
            case 'shareViewDelete':
                return await this.viewsService.shareViewDelete(context, {
                    viewId: req.query.viewId,
                    user: req.user,
                    req
                });
            case 'showAllColumns':
                return await this.viewsService.showAllColumns(context, {
                    viewId: req.query.viewId,
                    ignoreIds: req.query.ignoreIds,
                    levelId: req.query.levelId
                });
            case 'hideAllColumns':
                return await this.viewsService.hideAllColumns(context, {
                    viewId: req.query.viewId,
                    ignoreIds: req.query.ignoreIds,
                    levelId: req.query.levelId
                });
            case 'viewColumnUpdate':
                return await this.viewColumnsService.columnUpdate(context, {
                    viewId: req.query.viewId,
                    columnId: req.query.columnId,
                    column: payload,
                    req
                });
            case 'gridColumnUpdate':
                return await this.gridColumnsService.gridColumnUpdate(context, {
                    gridViewColumnId: req.query.gridViewColumnId,
                    grid: payload,
                    req
                });
            case 'viewColumnCreate':
                return await this.viewColumnsService.columnAdd(context, {
                    viewId: req.query.viewId,
                    column: payload,
                    req
                });
            case 'viewRowColorConditionAdd':
                return await this.viewRowColorService.addRowColoringCondition({
                    context,
                    fk_view_id: req.query.viewId,
                    color: payload.color,
                    is_set_as_background: payload.is_set_as_background,
                    nc_order: payload.nc_order,
                    type: payload.type,
                    fk_target_column_id: payload.fk_target_column_id,
                    filter: payload.filter
                });
            case 'viewRowColorConditionUpdate':
                return await this.viewRowColorService.updateRowColoringCondition({
                    context,
                    fk_view_id: req.query.viewId,
                    fk_row_coloring_conditions_id: req.query.rowColorConditionId,
                    color: payload.color,
                    is_set_as_background: payload.is_set_as_background,
                    nc_order: payload.nc_order,
                    type: payload.type,
                    fk_target_column_id: payload.fk_target_column_id
                });
            case 'viewRowColorConditionDelete':
                return await this.viewRowColorService.deleteRowColoringCondition({
                    context,
                    fk_view_id: req.query.viewId,
                    fk_row_coloring_conditions_id: req.query.rowColorConditionId
                });
            case 'viewRowColorSelectAdd':
                return await this.viewRowColorService.setRowColoringSelect({
                    context,
                    fk_view_id: req.query.viewId,
                    fk_column_id: payload.fk_column_id,
                    is_set_as_background: payload.is_set_as_background
                });
            case 'viewRowColorInfoDelete':
                return await this.viewRowColorService.removeRowColorInfo({
                    context,
                    fk_view_id: req.query.viewId
                });
            case 'filterCreate':
                return await this.filtersService.filterCreate(context, {
                    viewId: req.query.viewId,
                    filter: payload,
                    user: req.user,
                    req
                });
            case 'filterUpdate':
                return await this.filtersService.filterUpdate(context, {
                    filterId: req.query.filterId,
                    filter: payload,
                    user: req.user,
                    req
                });
            case 'filterDelete':
                return await this.filtersService.filterDelete(context, {
                    filterId: req.query.filterId,
                    req
                });
            case 'sortCreate':
                return await this.sortsService.sortCreate(context, {
                    viewId: req.query.viewId,
                    sort: payload,
                    req
                });
            case 'sortUpdate':
                return await this.sortsService.sortUpdate(context, {
                    sortId: req.query.sortId,
                    sort: payload,
                    req
                });
            case 'sortDelete':
                return await this.sortsService.sortDelete(context, {
                    sortId: req.query.sortId,
                    req
                });
            case 'hookCreate':
                return await this.hooksService.hookCreate(context, {
                    tableId: req.query.tableId,
                    hook: payload,
                    req
                });
            case 'hookUpdate':
                return await this.hooksService.hookUpdate(context, {
                    hookId: req.query.hookId,
                    hook: payload,
                    req
                });
            case 'hookDelete':
                return await this.hooksService.hookDelete(context, {
                    hookId: req.query.hookId,
                    req
                });
            case 'hookTest':
                return await this.hooksService.hookTest(context, {
                    hookTest: _extends({}, payload, {
                        payload: _extends({}, payload.payload, {
                            user: req.user
                        })
                    }),
                    tableId: req.query.tableId,
                    req
                });
            case 'hookTrigger':
                return await this.hooksService.hookTrigger(context, {
                    hookId: req.query.hookId,
                    rowId: req.query.rowId,
                    req
                });
            case 'hookFilterCreate':
                return await this.filtersService.hookFilterCreate(context, {
                    hookId: req.query.hookId,
                    filter: payload,
                    user: req.user,
                    req
                });
            case 'gridViewCreate':
                return await this.gridsService.gridViewCreate(context, {
                    grid: payload,
                    tableId: req.query.tableId,
                    req
                });
            case 'formViewCreate':
                return await this.formsService.formViewCreate(context, {
                    body: payload,
                    tableId: req.query.tableId,
                    user: req.user,
                    req
                });
            case 'galleryViewCreate':
                return await this.galleriesService.galleryViewCreate(context, {
                    gallery: payload,
                    tableId: req.query.tableId,
                    user: req.user,
                    req
                });
            case 'kanbanViewCreate':
                return await this.kanbansService.kanbanViewCreate(context, {
                    kanban: payload,
                    tableId: req.query.tableId,
                    user: req.user,
                    req
                });
            case 'mapViewCreate':
                return await this.mapsService.mapViewCreate(context, {
                    map: payload,
                    tableId: req.query.tableId,
                    user: req.user,
                    req
                });
            case 'calendarViewCreate':
                return await this.calendarsService.calendarViewCreate(context, {
                    calendar: payload,
                    tableId: req.query.tableId,
                    user: req.user,
                    req
                });
            case 'gridViewUpdate':
                return await this.gridsService.gridViewUpdate(context, {
                    viewId: req.query.viewId,
                    grid: payload,
                    req
                });
            case 'formViewUpdate':
                return await this.formsService.formViewUpdate(context, {
                    formViewId: req.query.viewId,
                    form: payload,
                    req
                });
            case 'formColumnUpdate':
                return await this.formColumnsService.columnUpdate(context, {
                    formViewColumnId: req.query.formColumnId,
                    formViewColumn: payload,
                    req
                });
            case 'galleryViewUpdate':
                return await this.galleriesService.galleryViewUpdate(context, {
                    galleryViewId: req.query.viewId,
                    gallery: payload,
                    req
                });
            case 'kanbanViewUpdate':
                return await this.kanbansService.kanbanViewUpdate(context, {
                    kanbanViewId: req.query.viewId,
                    kanban: payload,
                    req
                });
            case 'mapViewUpdate':
                return await this.mapsService.mapViewUpdate(context, {
                    mapViewId: req.query.viewId,
                    map: payload,
                    req
                });
            case 'calendarViewUpdate':
                return await this.calendarsService.calendarViewUpdate(context, {
                    calendarViewId: req.query.viewId,
                    calendar: payload,
                    req
                });
            case 'nestedDataLink':
                return await this.dataTableService.nestedLink(context, {
                    modelId: req.query.tableId,
                    rowId: req.query.rowId,
                    query: req.query,
                    viewId: req.query.viewId,
                    columnId: req.query.columnId,
                    refRowIds: payload,
                    cookie: req,
                    user: req.user
                });
            case 'nestedDataUnlink':
                return await this.dataTableService.nestedUnlink(context, {
                    modelId: req.query.tableId,
                    rowId: req.query.rowId,
                    query: req.query,
                    viewId: req.query.viewId,
                    columnId: req.query.columnId,
                    refRowIds: payload,
                    cookie: req,
                    user: req.user
                });
            case 'nestedDataListCopyPasteOrDeleteAll':
                return await this.dataTableService.nestedListCopyPasteOrDeleteAll(context, {
                    modelId: req.query.tableId,
                    query: req.query,
                    viewId: req.query.viewId,
                    columnId: req.query.columnId,
                    data: payload,
                    cookie: req,
                    user: req.user
                });
            case 'bulkAggregate':
                context.cache = true;
                return await this.dataTableService.bulkAggregate(context, {
                    query: req.query,
                    modelId: req.query.tableId,
                    viewId: req.query.viewId,
                    baseId: req.query.baseId,
                    body: payload
                });
            case 'bulkDataList':
                return await this.dataTableService.bulkDataList(context, {
                    query: req.query,
                    modelId: req.query.tableId,
                    viewId: req.query.viewId,
                    baseId: req.query.baseId,
                    body: payload,
                    user: req.user
                });
            case 'dataExport':
                {
                    var _payload_options;
                    const view = await _models.View.get(context, req.query.viewId);
                    if (!view) _catchError.NcError.viewNotFound(req.query.viewId);
                    const options = (_payload_options = payload.options) != null ? _payload_options : {};
                    const job = await this.nocoJobsService.add(_Jobs.JobTypes.DataExport, {
                        context,
                        options: _extends({}, options, {
                            // includeByteOrderMark when export is triggered from controller
                            includeByteOrderMark: true
                        }),
                        modelId: view.fk_model_id,
                        viewId: req.query.viewId,
                        user: req.user,
                        exportAs: payload.exportAs,
                        ncSiteUrl: req.ncSiteUrl
                    });
                    return {
                        id: job.id,
                        name: job.name
                    };
                }
            case 'dataInsert':
                return await this.dataTableService.dataInsert(context, {
                    modelId: req.query.tableId,
                    body: payload,
                    viewId: req.query.viewId,
                    cookie: req,
                    undo: req.query.undo === 'true',
                    user: req.user
                });
            case 'dataUpdate':
                return await this.dataTableService.dataUpdate(context, {
                    modelId: req.query.tableId,
                    body: payload,
                    viewId: req.query.viewId,
                    cookie: req,
                    user: req.user
                });
            case 'dataDelete':
                return await this.dataTableService.dataDelete(context, {
                    modelId: req.query.tableId,
                    cookie: req,
                    viewId: req.query.viewId,
                    body: payload,
                    user: req.user
                });
            case 'bulkDataDeleteAll':
                return await this.bulkDataAliasService.bulkDataDeleteAll(context, {
                    baseName: context.base_id,
                    tableName: req.query.tableId,
                    query: req.query,
                    viewName: req.query.viewId,
                    req
                });
            case 'commentRow':
                return await this.commentsService.commentRow(context, {
                    body: payload,
                    user: req.user,
                    req
                });
            case 'commentUpdate':
                return await this.commentsService.commentUpdate(context, {
                    commentId: payload.commentId,
                    user: req.user,
                    body: payload,
                    req
                });
            case 'commentDelete':
                return await this.commentsService.commentDelete(context, {
                    commentId: payload.commentId,
                    user: req.user,
                    req
                });
            case 'syncSourceCreate':
                return await this.syncService.syncCreate(context, {
                    baseId: context.base_id,
                    sourceId: req.query.sourceId,
                    userId: req.user.id,
                    syncPayload: payload,
                    req
                });
            case 'syncSourceUpdate':
                return await this.syncService.syncUpdate(context, {
                    syncId: req.query.syncId,
                    syncPayload: payload,
                    req
                });
            case 'syncSourceDelete':
                return await this.syncService.syncDelete(context, {
                    syncId: req.query.syncId,
                    req
                });
            case 'atImportTrigger':
                {
                    const jobs = await this.nocoJobsService.getJobList();
                    const fnd = jobs.find((j)=>j.data.syncId === req.query.syncId);
                    if (fnd) {
                        _catchError.NcError.badRequest('Sync already in progress');
                    }
                    const syncSource = await _models.SyncSource.get(context, req.query.syncId);
                    const user = await syncSource.getUser();
                    // Treat default baseUrl as siteUrl from req object
                    let baseURL = req.ncSiteUrl;
                    // if environment value avail use it
                    // or if it's docker construct using `PORT`
                    if (process.env.NC_DOCKER) {
                        baseURL = `http://localhost:${process.env.PORT || 8080}`;
                    }
                    const job = await this.nocoJobsService.add(_Jobs.JobTypes.AtImport, _extends({
                        context,
                        syncId: req.query.syncId
                    }, (syncSource == null ? void 0 : syncSource.details) || {}, {
                        baseId: syncSource.base_id,
                        sourceId: syncSource.source_id,
                        authToken: '',
                        baseURL,
                        user: user
                    }));
                    return {
                        id: job.id
                    };
                }
            case 'extensionCreate':
                return await this.extensionsService.extensionCreate(context, {
                    extension: payload,
                    req
                });
            case 'extensionUpdate':
                return await this.extensionsService.extensionUpdate(context, {
                    extensionId: req.query.extensionId,
                    extension: payload,
                    req
                });
            case 'extensionDelete':
                return await this.extensionsService.extensionDelete(context, {
                    extensionId: req.query.extensionId,
                    req
                });
        }
    }
    constructor(dataTableService, tablesService, columnsService, viewsService, viewColumnsService, viewRowColorService, filtersService, sortsService, hooksService, gridsService, gridColumnsService, formsService, formColumnsService, galleriesService, kanbansService, mapsService, calendarsService, commentsService, bulkDataAliasService, syncService, nocoJobsService, extensionsService){
        this.dataTableService = dataTableService;
        this.tablesService = tablesService;
        this.columnsService = columnsService;
        this.viewsService = viewsService;
        this.viewColumnsService = viewColumnsService;
        this.viewRowColorService = viewRowColorService;
        this.filtersService = filtersService;
        this.sortsService = sortsService;
        this.hooksService = hooksService;
        this.gridsService = gridsService;
        this.gridColumnsService = gridColumnsService;
        this.formsService = formsService;
        this.formColumnsService = formColumnsService;
        this.galleriesService = galleriesService;
        this.kanbansService = kanbansService;
        this.mapsService = mapsService;
        this.calendarsService = calendarsService;
        this.commentsService = commentsService;
        this.bulkDataAliasService = bulkDataAliasService;
        this.syncService = syncService;
        this.nocoJobsService = nocoJobsService;
        this.extensionsService = extensionsService;
        this.operations = [
            'tableUpdate',
            'tableDelete',
            'tableReorder',
            'columnAdd',
            'columnUpdate',
            'columnDelete',
            'columnSetAsPrimary',
            'columnsBulk',
            'viewUpdate',
            'viewDelete',
            'shareView',
            'shareViewUpdate',
            'shareViewDelete',
            'showAllColumns',
            'hideAllColumns',
            'viewColumnUpdate',
            'viewColumnCreate',
            'gridColumnUpdate',
            'viewRowColorConditionAdd',
            'viewRowColorConditionUpdate',
            'viewRowColorConditionDelete',
            'viewRowColorSelectAdd',
            'viewRowColorInfoDelete',
            'filterCreate',
            'filterUpdate',
            'filterDelete',
            'sortCreate',
            'sortUpdate',
            'sortDelete',
            'hookCreate',
            'hookUpdate',
            'hookDelete',
            'hookTest',
            'hookTrigger',
            'hookFilterCreate',
            'buttonFilterCreate',
            'gridViewCreate',
            'formViewCreate',
            'galleryViewCreate',
            'kanbanViewCreate',
            'mapViewCreate',
            'calendarViewCreate',
            'gridViewUpdate',
            'formViewUpdate',
            'formColumnUpdate',
            'galleryViewUpdate',
            'kanbanViewUpdate',
            'mapViewUpdate',
            'calendarViewUpdate',
            'nestedDataLink',
            'nestedDataUnlink',
            'nestedDataListCopyPasteOrDeleteAll',
            'linkFilterCreate',
            'widgetFilterCreate',
            'rowColorConditionsFilterCreate',
            'bulkAggregate',
            'bulkDataList',
            'dataInsert',
            'dataUpdate',
            'dataDelete',
            'bulkDataDeleteAll',
            'commentRow',
            'commentUpdate',
            'commentDelete',
            'commentResolve',
            'syncSourceCreate',
            'syncSourceUpdate',
            'syncSourceDelete',
            'atImportTrigger',
            'dataExport',
            'extensionCreate',
            'extensionUpdate',
            'extensionDelete',
            'listViewCreate',
            'listViewUpdate'
        ];
        this.httpMethod = 'POST';
    }
};
UiPostOperations = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datatableservice.DataTableService === "undefined" ? Object : _datatableservice.DataTableService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService,
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService,
        typeof _viewsservice.ViewsService === "undefined" ? Object : _viewsservice.ViewsService,
        typeof _viewcolumnsservice.ViewColumnsService === "undefined" ? Object : _viewcolumnsservice.ViewColumnsService,
        typeof _viewrowcolorservice.ViewRowColorService === "undefined" ? Object : _viewrowcolorservice.ViewRowColorService,
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService,
        typeof _sortsservice.SortsService === "undefined" ? Object : _sortsservice.SortsService,
        typeof _hooksservice.HooksService === "undefined" ? Object : _hooksservice.HooksService,
        typeof _gridsservice.GridsService === "undefined" ? Object : _gridsservice.GridsService,
        typeof _gridcolumnsservice.GridColumnsService === "undefined" ? Object : _gridcolumnsservice.GridColumnsService,
        typeof _formsservice.FormsService === "undefined" ? Object : _formsservice.FormsService,
        typeof _formcolumnsservice.FormColumnsService === "undefined" ? Object : _formcolumnsservice.FormColumnsService,
        typeof _galleriesservice.GalleriesService === "undefined" ? Object : _galleriesservice.GalleriesService,
        typeof _kanbansservice.KanbansService === "undefined" ? Object : _kanbansservice.KanbansService,
        typeof _mapsservice.MapsService === "undefined" ? Object : _mapsservice.MapsService,
        typeof _calendarsservice.CalendarsService === "undefined" ? Object : _calendarsservice.CalendarsService,
        typeof _commentsservice.CommentsService === "undefined" ? Object : _commentsservice.CommentsService,
        typeof _bulkdataaliasservice.BulkDataAliasService === "undefined" ? Object : _bulkdataaliasservice.BulkDataAliasService,
        typeof _syncservice.SyncService === "undefined" ? Object : _syncservice.SyncService,
        typeof _nocojobsservice.NocoJobsService === "undefined" ? Object : _nocojobsservice.NocoJobsService,
        typeof _extensionsservice.ExtensionsService === "undefined" ? Object : _extensionsservice.ExtensionsService
    ])
], UiPostOperations);
